<template>
  <div class="c-list-tile">
    <div class="c-avt"><cmid-avatar :cmid="cmid" :cid="cid" :cms="cms" :size="40" /></div>
    <div class="c-msg-area">
      <div class="c-title">{{ getCmName(cms[cmid], cid) }}</div>
      <div class="c-comment">{{ c }}</div>
    </div>
    <div class="c-time">{{ fmtTime(t) }}</div>
  </div>
</template>

<script>
import { CONST } from '../../constant';

export default {
  props: {
    cid: { type: Number, required: true },
    cmid: { type: Number, required: true },
    cms: { type: Object, required: true },
    c: { type: String, required: false, default: '' },
    t: { type: Number, required: true },
  },
  methods: {
    fmtTime(t) {
      return this.diffDateFormatShort(this.$moment.unix(t));
    },
  },
};
</script>

<style scoped>
.c-list-tile {
  display: flex;
  position: relative;
  padding: 12px 0 10px 0;
  overflow-x: hidden;
}
.c-avt {
  width: 60px;
  min-width: 60px;
  text-align: center;
}
.c-msg-area {
  flex-grow: 1;
}
.c-title {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
}
.c-comment {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
.c-time {
  position: absolute;
  top: 0;
  right: 10px;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
}
.c-cover-40 {
  padding-left: 6px;
  margin-top: -36px;
}
</style>
